module.exports = __webpack_public_path__ + "static/media/screenshot-1.cd3d4eb0.png";